










import { Component, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation } from 'vuex-class';

@Component({
    props: {
        onClickFunction: Function,
        options: Array,
    },
})
export default class SelectComponent extends Vue {
    private onClick(clickEvent: any) {
        const selectedOption = clickEvent.target.selectedOptions[0].id;
        this.$props.onClickFunction(selectedOption);
    }
}
